import styled from '@emotion/styled'

export const UlWrapper = styled.ul`
  list-style-type: square;
  padding: revert;
`
